import * as JsCookie from 'js-cookie'
export class Cookie<ValueType> {
  constructor(private name, private exdays: number | null = null) {}

  set(value: ValueType): void {
    this.exdays
      ? JsCookie.set(this.name, value, { expires: this.exdays })
      : JsCookie.set(this.name, value)
  }

  get value(): ValueType {
    const value = JsCookie.get(this.name) || ''
    try {
      return JSON.parse(value) as any
    } catch {
      return value as any
    }
  }
}
